import { Injectable } from '@angular/core';
import { LoggerEventsEnum } from '@pwaPortal/core/enums/logger-events.enum';
import { HelperService } from '@pwaPortal/core/services/helper/helper.service';
import { LoggerService } from '@pwaPortal/core/services/logger/logger.service';
import { OneSignal } from 'onesignal-ngx';
import { IPushNotifications } from '../../interfaces/IPushNotifications';

@Injectable({
  providedIn: 'root',
})
export class OneSignalNotificationsService implements IPushNotifications {
  constructor(
    private oneSignal: OneSignal,
    private logger: LoggerService,
    private helperService: HelperService
  ) {}

  async init(): Promise<void> {
    const clientId = this.helperService.getUserId();
    const config = await this.helperService.getPwaConfig();

    // one_signal_id - from config
    // clientId - from cookie
    if (!config.onesignalAppId) return;
    await this.oneSignal.init({
      appId: config.onesignalAppId,
    });
    await this.oneSignal.login(clientId);
    this.oneSignal.Notifications.addEventListener('permissionChange', (event) => {
      console.log('The notification was clicked!', event);
    });
  }

  async requestPermissions(): Promise<void> {
    const config = await this.helperService.getPwaConfig();
    if (!config.onesignalAppId) return;
    this.oneSignal.Notifications.requestPermission().then(() => {
      console.log('requestPermission');
      if (this.oneSignal.Notifications.permissionNative === 'granted') {
        this.logger.sendFetchEvent(LoggerEventsEnum.PUSH_SUBSCRIPTION);
        console.log('sending PUSH_SUBSCRIPTION event');
      }
    });
  }
}
